import { useEffect } from 'react'
import { create } from 'zustand'

type AppbarTitleStore = {
    appTitle: string
    setTitle: (title: string) => void
}

export const useAppbarTitleStore = create<AppbarTitleStore>((set) => ({
    appTitle: '',
    setTitle: (title) => set({ appTitle: title }),
}))

export const usePageTitle = (title: string) => {
    const setTitle = useAppbarTitleStore((s) => s.setTitle)

    useEffect(() => {
        setTitle(title)
        document.title = title ? `${title} - Mockingbird` : 'Mockingbird'
    }, [title, setTitle])
}
